import { Component } from '@angular/core';
import { ModalService } from '@app/services/modal.service';

@Component({
  selector: 'app-modal-qr-error',
  templateUrl: './modal-qr-error.component.html',
  styleUrls: ['./modal-qr-error.component.scss']
})
export class ModalQrErrorComponent {

  constructor(public modal: ModalService) {}

  ngOnDestroy() {
    this.modal.close();
  }

  goToStart() {
    this.modal.close();
  }
}
